import React from 'react';
import { motion } from 'framer-motion';
import { Instagram } from 'lucide-react';
export function InstagramFeed() {
  const images = ['https://cdn.magicpatterns.com/uploads/ktAKe94iYLBG7f5BoUF5iH/SaveClip.App_588706853_17949148398062830_2502129062488998371_n.jpg', 'https://cdn.magicpatterns.com/uploads/whYNB3UyDgecLuwXayek8v/SaveClip.App_703382700_17969420592062830_616045647863297315_n.jpg', 'https://cdn.magicpatterns.com/uploads/wEpTncgKKfS2Ear6zZ9aai/SaveClip.App_704898637_18405959770194389_4178243808241177943_n.jpg', 'https://cdn.magicpatterns.com/uploads/vMFd7T97bGtDWauh8CcZMj/SaveClip.App_720602386_17972513367062830_3279254976713242237_n.jpg', 'https://cdn.magicpatterns.com/uploads/4zAhsekd8DfwnZFenYaMKo/SaveClip.App_587781476_17949148443062830_9006934532259931911_n.jpg', 'https://cdn.magicpatterns.com/uploads/cTicapXcsPCGHJmSeiUnv3/SaveClip.App_706028766_17970555336062830_663631352342535976_n.jpg'];
  return <section className="py-24 bg-cream" data-id="element-119">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-120">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6" data-id="element-121">
          <div data-id="element-122">
            <h2 className="text-sm font-medium text-rosegold tracking-widest uppercase mb-3" data-id="element-123">
              Portfolio
            </h2>
            <h3 className="text-3xl md:text-4xl font-serif text-charcoal flex items-center gap-3" data-id="element-124">
              Seguinos en Instagram{' '}
              <a href="https://instagram.com/studiomery_" target="_blank" rel="noopener noreferrer" className="text-rosegold hover:text-rosegold-dark transition-colors" data-id="element-125">
                @studiomery_
              </a>
            </h3>
          </div>
          <a href="https://instagram.com/studiomery_" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 border border-charcoal text-charcoal px-6 py-2.5 rounded-full font-medium hover:bg-charcoal hover:text-white transition-colors" data-id="element-126">
            <Instagram size={18} data-id="element-127" />
            Ver más en Instagram
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-128">
          {images.map((src, idx) => <motion.a href="https://instagram.com/studiomery_" target="_blank" rel="noopener noreferrer" key={idx} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="relative aspect-square overflow-hidden group cursor-pointer rounded-xl" data-id="element-129">
              <img src={src} alt={`Instagram post ${idx + 1}`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-130" />
              <div className="absolute inset-0 bg-charcoal/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col items-center justify-center gap-2 backdrop-blur-[2px]" data-id="element-131">
                <Instagram className="text-white w-8 h-8" data-id="element-132" />
                <span className="text-white text-sm font-medium tracking-wide" data-id="element-133">
                  Ver en Instagram
                </span>
              </div>
            </motion.a>)}
        </div>

        {/* Delicate Call to Action Banner */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mt-16 bg-white rounded-3xl p-8 md:p-12 text-center shadow-sm border border-cream-dark max-w-4xl mx-auto relative overflow-hidden" data-id="element-134">
          {/* Subtle decorative elements */}
          <div className="absolute -top-10 -left-10 w-32 h-32 bg-rosegold/5 rounded-full blur-2xl" data-id="element-135"></div>
          <div className="absolute -bottom-10 -right-10 w-32 h-32 bg-subtlegold/10 rounded-full blur-2xl" data-id="element-136"></div>

          <div className="relative z-10" data-id="element-137">
            <h4 className="text-2xl md:text-3xl font-serif text-charcoal mb-3" data-id="element-138">
              ¿Lista para lucir unas manos perfectas?
            </h4>
            <p className="text-charcoal-light font-light mb-8 max-w-lg mx-auto" data-id="element-139">
              Agendá tu sesión de manicura y dejá que nos encarguemos de cada
              detalle.
            </p>
            <button onClick={() => window.open('https://studiomery.koob.uy', '_blank', 'noopener,noreferrer')} className="group relative inline-flex items-center justify-center px-8 py-3.5 text-rosegold font-medium text-sm tracking-wide uppercase overflow-hidden rounded-full border border-rosegold/30 hover:border-rosegold transition-colors duration-300 bg-white shadow-[0_0_15px_rgba(201,149,108,0.1)] hover:shadow-[0_0_25px_rgba(201,149,108,0.25)]" data-id="element-140">
              <span className="relative z-10 flex items-center gap-2 transition-transform duration-300 group-hover:scale-105" data-id="element-141">
                Reservar mi manicura
                <svg className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-142">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" data-id="element-143" />
                </svg>
              </span>
              <div className="absolute inset-0 bg-rosegold/5 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" data-id="element-144"></div>
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}